import { ReactComponent as LeftIcon } from '../../../static/chevron_left_black_24dp.svg';
import { generateStyledIcon } from '../Arrow.styles';

export const S = {
  LeftArrowIcon: generateStyledIcon(LeftIcon),
};
